import type { Tag } from '@/types';
import { createNamedContext } from '@/utils';

export const GroupTagsContext = createNamedContext<Tag[]>([], 'GroupTagsContext');